/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "apolloapi",
            "endpoint": "https://hyfv77z3mh.execute-api.us-west-2.amazonaws.com/main",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
